<template>
  <div class="print-card">
    <a class="print-link" :href="pdf.url" :target="pdf.target">
      <img
        class="print-image"
        :src="pdf.image"
        :srcset="pdf.imageSrcset"
        width="100%"
        height="100%"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'PrintCard',
  props: {
    pdf: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="postcss">
.print {
  &-card {
    height: auto;
  }
  &-link {
    height: 100%;
    text-decoration: none;
    &:hover {
      border-bottom: none;
      text-decoration: none;
    }
  }
}
</style>
